const FaqPage = () => import('@/modules/Faq/containers');
const FaqWiki = () => import('@/modules/Faq/containers/FaqDocs');

export const Faq = {
  path: '/faq',
  name: 'faq',
  component: FaqPage,
};

export const FaqDocs = {
  path: '/faq/:categ/:page',
  name: 'faq-docs',
  component: FaqWiki,
};




// WEBPACK FOOTER //
// ./src/modules/Faq/routes.js